import React from "react";
import { AccountRulePresence } from "@common/types/domains/accounting/account";
import { FilterMultiselectOption } from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import { TriStateBooleanFilter } from "../TriStateBooleanFilter/TriStateBooleanFilter";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";

const hasRuleOption: FilterMultiselectOption = {
    value: AccountRulePresence.HAS_RULE,
    label: "Has rules",
    searchableLabel: "has rules",
};

const noRulesOption: FilterMultiselectOption = {
    value: AccountRulePresence.NO_RULES,
    label: "No rules",
    searchableLabel: "no rules",
};

const toHasRule = (
    presence: AccountRulePresence | undefined,
): boolean | undefined => {
    if (presence === undefined) {
        return undefined;
    }
    return presence === AccountRulePresence.HAS_RULE;
};

const toPresence = (
    hasRule: boolean | undefined,
): AccountRulePresence | undefined => {
    if (hasRule === undefined) {
        return undefined;
    }
    return hasRule
        ? AccountRulePresence.HAS_RULE
        : AccountRulePresence.NO_RULES;
};

export const AccountRulePresenceFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <div className={styles.filter}>
        <TriStateBooleanFilter
            value={toHasRule(filters.accountRulePresence)}
            onChange={(hasRule) =>
                onChange({ accountRulePresence: toPresence(hasRule) })
            }
            trueOption={hasRuleOption}
            falseOption={noRulesOption}
            name="accountRulePresence"
        />
    </div>
);
